export enum AdminOrderAction {
  ForceConfirm = "force-confirm",
  ResendDrivers = "resend-drivers",
  Cancel = "cancel",
}
